import { gql } from 'apollo-angular';

const GET_RFP_PERMISSIONS = gql`
  query getRfpPermissions($rfpId: Long!) {
    permissions(contextId: $rfpId) {
      hasAccess
      reasonForDenial
      permissionType
    }
  }
`;

export default GET_RFP_PERMISSIONS;
